import { Headline, Paragraph } from 'View/Common';
import { HoverImageLink, Slider } from 'View/Component';
import { FC, useEffect, useState } from 'react';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import { CooperationStyle } from './HealthCooperations.style';
import { ISliderSettings, useSliderSettings } from 'View/HookApi/useSliderSettings';
import { useGetInsuranceCompaniesQuery } from 'api/graphql';

type THealthCooperationsProps = {
  id: string;
};

export const HealthCooperations: FC<THealthCooperationsProps> = ({ id }) => {
  const [totalLogoCount, setTotalLogoCount] = useState(0);

  const { loading, data } = useGetInsuranceCompaniesQuery({
    variables: {
      isCooperationPartner: true,
    },
  });
  const { insuranceCompanies } = data || {};

  useEffect(() => {
    setTotalLogoCount(insuranceCompanies?.length ?? 0);
  }, [insuranceCompanies]);

  const settings: ISliderSettings = useSliderSettings(totalLogoCount);

  if (!insuranceCompanies || totalLogoCount === 0) {
    return;
  }

  return (
    <CooperationStyle id={id} className="text-center" type="full-width">
      <Headline level={2}>Starte ohne Vorauszahlung</Headline>
      <Paragraph className="subline">bei diesen Krankenkassen</Paragraph>
      <div className="slider-wrapper">
        <Slider key={settings.initialSlide} settings={settings}>
          {insuranceCompanies.map((cooperation) =>
            cooperation.cooperationLogo && cooperation.cooperationLogoHover ? (
              <HoverImageLink
                key={cooperation.cooperationUrl}
                image={cooperation.cooperationLogo}
                hoverImage={cooperation.cooperationLogoHover}
                href={cooperation.cooperationUrl}
                className="logo"
              />
            ) : null,
          )}
        </Slider>
      </div>
      <Paragraph className="info-text">
        Wenn du bei einer unserer Kooperations-Krankenkassen versichert bist, kannst du den Präventionskurs sogar direkt starten, ganz ohne
        Vorauszahlung. Einfach auf das Logo deiner Krankenkasse klicken und mehr erfahren.
      </Paragraph>
    </CooperationStyle>
  );
};
